import { render, staticRenderFns } from "./VerifyRF.vue?vue&type=template&id=c6a67c9e"
import script from "./VerifyRF.vue?vue&type=script&lang=js"
export * from "./VerifyRF.vue?vue&type=script&lang=js"
import style0 from "./VerifyRF.vue?vue&type=style&index=0&id=c6a67c9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports